import { match } from 'ts-pattern'

import { DocumentTypeOption } from '@documents/types'

export function getUploadHeading(documentType: DocumentTypeOption | null, hideW2s: boolean): string {
  return match(documentType)
    .with(DocumentTypeOption.PAYSTUB_OR_W2, () => (hideW2s ? 'upload paystubs' : 'upload paystubs or W2s'))
    .with(DocumentTypeOption.OFFER_LETTER, () => 'upload offer letter')
    .otherwise(() => 'upload documents')
}
